import { moduleConfig } from '@/core/config'
import { groupBy } from '@/utils/utils'
// import snippets from './snippets'
import document from './document'

export interface CompletionItem {
  label?: string
  documentation?: string
  insertText?: string
  kind?: any
}

export interface DocumentItem {
  name?: string
  groupName?: string
  desc?: string
  sample?: string
}

export const getDocumentByName = (name: string): string => {
  const docs = (document[moduleConfig.language] as any[])
  return docs.find(x => x.name == name)?.sample
}

export const getDocumentItems = (): { [key: string]: DocumentItem[] } => {
  const docs = (document[moduleConfig.language] as any[])
  return groupBy(docs, x => x.groupName)
}

export const getCompletionItems = (kind: number): CompletionItem[] => {
  // const items = snippets.map(x => {
  //   const item: DocumentItem = {
  //     label: x.name,
  //     documentation: x.name,
  //     insertText: x.content,
  //     kind
  //   }
  //   return item;
  // })
  const items = (document[moduleConfig.language] as any[])
    .filter(x => !!x.snippet)
    .map(x => {
      const item: CompletionItem = {
        label: x.name,
        documentation: x.desc,
        insertText: x.snippet,
        kind
      }
      return item
    });
  return items
}
